<template>
  <div class="button-video">
    <div class="button-video__wrapper">
      <div
        v-if="pic"
        class="button-video__pic"
      >
        <div :class="pic" />

        <div class="picto-youtube" />
      </div>

      <component
        :is="to !== null ? 'router-link' : 'div'"
        :to="to"
        class="button-video__label"
      >
        <span v-if="label">{{ label }}</span>
      </component>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: null },
    pic: { type: String, default: null },
    to: { type: [String, Object], default: null },
  },
};
</script>

<style lang="stylus">
.button-video {
  $pic-size = 80px;

  &__wrapper {
    position: relative;
    height: $pic-size;
  }

  &__pic {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;

    box-sizing: border-box;
    width: $pic-size;
    height: @width;

    overflow hidden;
    border-radius: @width;
    background-color: #ffffff55;

    .picto-youtube {
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 50%;

      transform: translate(-50%, -50%);
      transition: transform 0.5s $ease-out-cubic;

      +pointer-device() {
        .button-video:hover & {
          transform: translate(-50%, -50%) scale(0.85);
          transition: transform 0.35s $ease-in-out-cubic;
        }
      }
    }
  }

  &__label {
    @extend $typo-landing-bottom-button;

    position: relative;
    z-index: 1;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    max-width: (300px + 80 + 15);
    height: 100%;
    margin-left: 15px;
    padding-left: $pic-size;

    color: $cl-white;
    text-align: left;
    text-decoration: underline !important;

    .button-video:hover & {
      text-decoration: none !important;
    }
  }
}
</style>
